import React from "react";

import { ROUTES } from "../../../system/router/routes";

import * as Styled from "./home.styled";
import { ReactComponent as LegacyLinkLogo } from "../assets/legacy-link-logo-big.svg";
import { ReactComponent as ArrowLeft } from "../assets/arrow-left.svg";

export const Home = () => {
  return (
    <Styled.Container>
      <Styled.Title>Search across everything</Styled.Title>
      <Styled.Description>
        Find data across all available facilities and applications
      </Styled.Description>
      <Styled.Search to={ROUTES.SEARCH}>
        <LegacyLinkLogo />
        <Styled.SearchLinkText>
          Search <ArrowLeft />
        </Styled.SearchLinkText>
      </Styled.Search>
    </Styled.Container>
  );
};
